import { type Dispatch, type SetStateAction, type MutableRefObject } from 'react';

import { getDwelledOnPage } from 'dibs-buyer-layout/exports/dwelledOnPage.ts';

import { canDisplayFavoritesNudge } from './canDisplayFavoritesNudge.ts';
import { setFavoritesNudgeDisplayed } from './setFavoritesNudgeDisplayed.ts';
import { updateFavoritesNudgeDisplayedCount } from './updateFavoritesNudgeDisplayedCount.ts';
import { getFavoritesNudgeDisplayedCount } from './getFavoritesNudgeDisplayedCount.ts';
import { wasPdpVisitedMultipleTimes } from '../../../pdp/PdpSharedNotifications/pdpSharedNotificationHelpers.js';

import { FIRST_FAVORITES_NUDGE_DELAY_MS } from '../constants.ts';

function scheduleNudgeDisplay({
    mountedRef,
    itemId,
    setIsVisible,
}: {
    mountedRef: MutableRefObject<boolean>;
    itemId: string | null | undefined;
    setIsVisible: Dispatch<SetStateAction<boolean>>;
}): (() => void) | null {
    const favoritesNudgeDisplayedCount = getFavoritesNudgeDisplayedCount();
    let isRepeatPdpVisit = false;

    if (itemId) {
        isRepeatPdpVisit = wasPdpVisitedMultipleTimes({ itemId });
    }

    function showNudge(): void {
        setIsVisible(true);
        setFavoritesNudgeDisplayed();
        updateFavoritesNudgeDisplayedCount();
    }

    if (favoritesNudgeDisplayedCount >= 1 && !isRepeatPdpVisit) {
        const intervalId = window.setInterval(() => {
            if (!canDisplayFavoritesNudge() || !mountedRef.current) {
                window.clearInterval(intervalId);
            } else if (getDwelledOnPage('search') || getDwelledOnPage('pdp')) {
                showNudge();
                window.clearInterval(intervalId);
            }
        }, 1000);

        return () => window.clearInterval(intervalId);
    }

    if (mountedRef.current) {
        const timeoutId = window.setTimeout(() => {
            if (mountedRef.current) {
                showNudge();
            }
        }, FIRST_FAVORITES_NUDGE_DELAY_MS);

        return () => window.clearTimeout(timeoutId);
    }

    return null;
}

export { scheduleNudgeDisplay };
